import { useWebSocketStore } from '@/store/useWebSocketStore.ts';

export const handleUserActivated = () => {
  const { setLastEvents } = useWebSocketStore.getState();

  setLastEvents({ userVerified: true });
};
